var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hxlHeader'),_c('div',{staticClass:"personalCenter"},[_c('hxlMenu',{staticClass:"menu"}),_c('hxlContent',{staticClass:"right"})],1),_c('hxlFooder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }